import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconEyeShowSvg } from './IconEyeShowSvg';

export const IconEyeShow: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconEyeShowSvg} {...iconProps} />;
};
